<script setup lang="ts">
type Props = {
  paddingClass?: string
}

withDefaults(defineProps<Props>(), {
  paddingClass: 'tw-px-6',
})
</script>

<template>
  <div>
    <slot name="title" />
    <div class="tw-flex tw-flex-wrap tw-gap-2" :class="paddingClass">
      <slot />
    </div>
  </div>
</template>
